module.exports = __webpack_public_path__ + "static/team-wall-8ff7abb51802adb49b9fae25c1b91c57.jpg";